export default {"src":"/_next/static/media/logo-10.1da1c5ea.svg","height":51,"width":50,"blurWidth":0,"blurHeight":0};